import { createApiHook } from '../hooks';
import { trackingApiFactory } from './trackingApiFactory';

export const useTrackingApi = createApiHook(trackingApiFactory);
